import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const FinalInvitation = () => <section className="final-section" aria-labelledby="final-title" data-testid="final-invitation">
  <div className="brand-container final-grid">
    <div className="final-mark"><img src="/brand/keepsake-symbol-vermilion-960.webp" width="960" height="960" loading="lazy" alt="The Keepsake Two Voices symbol in ivory on vermilion"/></div>
    <div className="final-copy">
      <h2 id="final-title" className="display-l">Make something <em>they’ll keep.</em></h2>
      <p className="lede">Your memories are already there. Let’s turn them into a book.</p>
      <Link to="/create/new" className="btn-primary" data-testid="bottom-create-cta">Create Your Keepsake <ArrowRight size={16}/></Link>
    </div>
  </div>
</section>;
